export default [
  {
    title: 'Sobre a ZiliCred',
    text: `A missão da ZiliCred é revolucionar o cenário do crédito no Brasil, oferecendo linhas de crédito com garantia de imóvel, se destacando como uma fonte de crédito segura e acessível.`,
  },
  {
    title: 'O que é o Consignado Imobiliário Zili?',
    text: `Nessa modalidade você terá um Limite de Crédito, que é baseado de acordo com o valor do seu imóvel. Você pode escolher o valor que pretende sacar e o prazo que melhor se encaixa no seu planejamento. A cada pagamento seu limite é restabelecido. Você so paga Juros e IOF sobre o valor usado, e não sobre o total.`,
  },
  {
    title: 'Quais são as etapas de contratação?',
    text: `
     Após selecionar a sua oferta em nossa plataforma, você será direcionado para a contratação na plataforma da ZiliCred:
      <ol>
        <li>Informe seus dados de residência para utilizar o imóvel como garantia;</li>
        <li>Escolha os valores e prazos da sua oferta;</li>
        <li>Envie seus documentos para a análise;</li>
        <li>Se aprovado, o seu limite de crédito será disponibilizado após o registro no cartório.</li>
      </ol>
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `
      <ol>
        <li>Cópia CNH e/ou CPF/RG com foto;</li>
        <li>Cópia do comprovante de endereço (contas de consumo emitidas no máximo há 60 dias);</li>
        <li>Comprovante Estado Civil;</li>
        <li>Se Assalariado: último holerite + Declaração do último IRPF;</li>
        <li>Se Aposentado: último comprovante + Declaração do último IRPF;</li>
        <li>Se Autônomo/Profissional liberal: 03 últimos extratos bancários + Declaração do último IRPF;</li>
        <li>Se Empresário: 03 últimos extratos bancários + Declaração do último IRPF + Contrato Social;</li>
        <li>Capa do IPTU + matrícula do imóvel.</li>
      </ol>
    `,
  },
  {
    title: `Qual a taxa de juros da ZiliCred?`,
    text: `A ZiliCred cobra uma taxa a partir de 0,99% ao mês.`,
  },
  {
    title: `Quais são os requisitos para pedir o empréstimo?`,
    text: `Para solicitar um empréstimo na ZiliCred é necessário possuir como garantia uma casa, apartamento ou sala comercial a partir de R$ 150.000,00 e renda familiar a partir de R$ 3.700,00.`,
  },
  {
    title: `Quanto tempo demora para saber se fui aprovado?`,
    text: `A aprovação será em até 24 horas após a entrega dos documentos solicitados.`,
  },
  {
    title: `Em quanto tempo vou receber o dinheiro na minha conta bancária?`,
    text: `O limite de crédito estará disponível na sua conta após registro do contrato no cartório.`,
  },
]
